<div class="platform-view-component" *ngIf="organization?.id">
    <div>Organization: {{organization.label}}</div>
    <app-edit-email-template [emailTemplateId]="emailTemplate.id"></app-edit-email-template>
</div>
